import { getUrl } from '../../../../utils/get-url.js';

/** Returns the name that belongs to a given route from the main menu */ function getNameByProductRoute(categoryRoute, page) {
    var ref;
    const menuDocumentRef = (ref = page === null || page === void 0 ? void 0 : page.getComponent('header', 'main-menu')) === null || ref === void 0 ? void 0 : ref.getModels().menu;
    const menu = menuDocumentRef && (page === null || page === void 0 ? void 0 : page.getContent(menuDocumentRef));
    if (!(menu === null || menu === void 0 ? void 0 : menu.getItems())) {
        return undefined;
    }
    const route = findRouteByUrl(categoryRoute, menu === null || menu === void 0 ? void 0 : menu.getItems());
    return route && route.getName();
}
/**  Returns the route for a given url and an array of menu items */ function findRouteByUrl(categoryRoute, routes) {
    for (const route of routes){
        var ref, ref1;
        if (((ref = route.getLink()) === null || ref === void 0 ? void 0 : ref.href) && ((ref1 = route.getLink()) === null || ref1 === void 0 ? void 0 : ref1.href) === categoryRoute) {
            return route;
        }
        // Check the childMenuItems for the route
        if (route.getChildren().length) {
            const result = findRouteByUrl(categoryRoute, route.getChildren());
            if (result) return result;
        }
    }
}
function createCategoryBreadcrumb(categoryRoute, page) {
    if (!page) {
        return null;
    }
    const name = getNameByProductRoute(categoryRoute, page);
    const url = getUrl(categoryRoute, page);
    return name ? {
        name,
        url
    } : null;
}

export { createCategoryBreadcrumb, getNameByProductRoute };
//# sourceMappingURL=create-category-breadcrumb.js.map
